import React, { useEffect } from "react";
import { View, StyleSheet, ActivityIndicator } from "react-native";
import { useNavigate, useLocation } from "react-router-dom";
import { useNavigationStore } from "../stores/storeContexts";
import { COLOR } from "../styles/Colors";

export const RedirectScreen = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { pushStack } = useNavigationStore();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const redirectUrl = params.get("url");

    if (redirectUrl) {
      localStorage.setItem("auth", "success");
      navigate(redirectUrl);
    } else {
      navigate("/platform");
    }
  }, [location, navigate, pushStack]);

  return (
    <View style={styles.container}>
      <ActivityIndicator
        size="large"
        color={COLOR.GREEN}
        style={{ alignSelf: "center", marginTop: 20 }}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});
